import { useContext } from 'react';
import { WorkflowContext } from '.';
import { useEffect, useState } from 'react';
import { useNavigate, Location, useBlocker } from 'react-router-dom';

export const useWorkflow = () => {
  const ctx = useContext(WorkflowContext);

  if (!ctx) throw new Error('useWorkflow must be within WorkflowContextProvider');

  return ctx;
};

export function useUnsavedChangesWarning(changes: boolean) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [lastLocation, setLastLocation] = useState<Location | null>(null);
  const [confirmedNavigation, setConfirmedNavigation] = useState(false);
  const navigate = useNavigate();
  const blocker = useBlocker(changes);

  useEffect(() => {
    if (blocker.state === 'blocked' && !isModalOpen) {
      setLastLocation(blocker.location);
      setIsModalOpen(true);
    }
  }, [blocker, isModalOpen]);

  const handleConfirmNavigation = () => {
    setIsModalOpen(false);
    setConfirmedNavigation(true);
  };

  useEffect(() => {
    if (confirmedNavigation && lastLocation) {
      navigate(lastLocation.pathname, { replace: true });
    }
  }, [confirmedNavigation, lastLocation, navigate]);

  return { isModalOpen, handleConfirmNavigation };
}
